// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"038b52d1","732":"766e52f7","977":"cb97c949"}[chunkId] + ".chunk.js";
};